module.exports = "/_next/static/images/top_ogp-4595dbbf98aa97507258d07dfa1f0ecb.png";